








































































































































































import { Component, Vue } from "vue-property-decorator";
import {Action} from "vuex-class";
import {EmailDetailItemInfo} from "@/store/email/statistic/types";
import EmailDetailInfoDialog from '@/components/Email/EmailDetailInfoDialog.vue';
import { colorClassByStatus } from "@/utils/page-utils";
import {dateFilter} from "@/utils/date-util";
import {notifyError} from "@/utils/notify-helper";

@Component({
  components: {EmailDetailInfoDialog},
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class EmailDetailInfo extends Vue {
  @Action("getEmailStatisticDetailInfo") actionGetStatisticDetailInfo: any;
  @Action("getEmailMessage") actionGetMessage!: any;

  defaultInfo(): EmailDetailItemInfo {
    return new EmailDetailItemInfo()
  }

  private messageInfo = this.defaultInfo();

  async created() {
    if (this.$route.params.id) {
      try {
        const resp = await this.actionGetStatisticDetailInfo(this.$route.params.id);
        this.messageInfo = Object.assign({}, this.messageInfo, resp.data);
      } catch(error) {
        notifyError(error);
      }
    }
  }

  back(): void {
    this.$router.push('/report/detailed/email');
  }

  private messageContent: string|null = null;
  private showMessage: boolean = false;

  async showMessageContent(id: string) {
    try {
      this.messageContent = await this.actionGetMessage(id);
      this.showMessage = true
    } catch(error) {
      notifyError(error);
    }
  }

}
